import styled, { css } from 'styled-components';

type CardProps = {
  isSelected: boolean;
};

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
  overflow-x: auto;
  display: block;

  td {
    padding: 10px;
    border: 1px solid #e0e0e0;
    text-align: left;

    @media (max-width: 768px) {
      padding: 8px;
      font-size: 13px;
    }

    @media (max-width: 480px) {
      padding: 6px;
      font-size: 12px;
    }
  }

  th {
    padding: 10px;
    border: 1px solid #e0e0e0;
    text-align: center;
    font-weight: 600;

    @media (max-width: 768px) {
      padding: 8px;
      font-size: 13px;
    }

    @media (max-width: 480px) {
      padding: 6px;
      font-size: 12px;
    }
  }

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }

  @media (max-width: 480px) {
    margin-bottom: 12px;
  }
`;

export const Card = styled.div<CardProps>`
  ${({ isSelected }) => css`
    margin: 15px;
    background: white;
    display: flex;
    flex-direction: column;
    border: none;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 0 10px 4px #3297fd;
    -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    cursor: pointer;
    min-height: 44px;

    h2 {
      font-size: 15px;

      @media (max-width: 768px) {
        font-size: 14px;
      }

      @media (max-width: 480px) {
        font-size: 13px;
      }
    }

    @media (max-width: 768px) {
      margin: 10px;
      padding: 12px;
      border-radius: 8px;
    }

    @media (max-width: 480px) {
      margin: 8px;
      padding: 10px;
    }

    ${!isSelected &&
    css`
      &::after {
        -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
        transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
      }

      &:hover {
        -webkit-transform: scale(1.05, 1.05);
        transform: scale(1.05, 1.05);
        &::after {
          opacity: 1;
        }

        @media (max-width: 768px) {
          -webkit-transform: scale(1.02, 1.02);
          transform: scale(1.02, 1.02);
        }
      }

      box-shadow: 0 0 10px 4px #d0d0d0;

      &:hover {
        box-shadow: 0 0 10px 4px #d0d0ff;
        -webkit-transform: scale(1.05, 1.05);
        transform: scale(1.05, 1.05);

        @media (max-width: 768px) {
          -webkit-transform: scale(1.02, 1.02);
          transform: scale(1.02, 1.02);
        }
      }
    `}
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 25px;
  margin-top: -20px;

  @media (max-width: 768px) {
    padding-left: 20px;
    margin-top: -16px;
  }

  @media (max-width: 480px) {
    padding-left: 16px;
    margin-top: -12px;
  }
`;

export const Input = styled.input`
  width: 10px;
  transform: scale(2);
  cursor: pointer;
  min-width: 44px;
  min-height: 44px;

  @media (max-width: 768px) {
    transform: scale(1.8);
  }

  @media (max-width: 480px) {
    transform: scale(1.6);
  }
`;
